import * as f from "react";
import { onIdTokenChanged as Ft } from "firebase/auth";
import { onChildAdded as Pt, onChildRemoved as $t, onChildChanged as Tt, onChildMoved as Dt, onValue as Rt, off as jt, get as Ut } from "firebase/database";
import { getApps as Vt, registerVersion as Ne, initializeApp as Mt } from "firebase/app";
import { onSnapshot as Lt, queryEqual as Nt } from "firebase/firestore";
import { httpsCallable as Wt } from "firebase/functions";
import { getDownloadURL as qt, ref as Qt } from "firebase/storage";
import { ensureInitialized as Kt, getValue as Ht, getString as Yt, getNumber as Gt, getBoolean as Jt, getAll as zt } from "firebase/remote-config";
var ce = function(e, t) {
  return ce = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, ce(e, t);
};
function x(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ce(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Zt(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function pe(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(u) {
      u(o);
    });
  }
  return new (n || (n = Promise))(function(o, u) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (d) {
        u(d);
      }
    }
    function s(l) {
      try {
        c(r.throw(l));
      } catch (d) {
        u(d);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(a, s);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function He(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, u;
  return u = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function a(c) {
    return function(l) {
      return s([c, l]);
    };
  }
  function s(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = c;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(c);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        r = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function V(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function D(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], u;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (a) {
    u = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return o;
}
function R(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function U(e) {
  return this instanceof U ? (this.v = e, this) : new U(e);
}
function Bt(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = {}, u("next"), u("throw"), u("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function u(v) {
    r[v] && (i[v] = function(p) {
      return new Promise(function(S, h) {
        o.push([v, p, S, h]) > 1 || a(v, p);
      });
    });
  }
  function a(v, p) {
    try {
      s(r[v](p));
    } catch (S) {
      d(o[0][3], S);
    }
  }
  function s(v) {
    v.value instanceof U ? Promise.resolve(v.value.v).then(c, l) : d(o[0][2], v);
  }
  function c(v) {
    a("next", v);
  }
  function l(v) {
    a("throw", v);
  }
  function d(v, p) {
    v(p), o.shift(), o.length && a(o[0][0], o[0][1]);
  }
}
function Xt(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof V == "function" ? V(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(u) {
      return new Promise(function(a, s) {
        u = e[o](u), i(a, s, u.done, u.value);
      });
    };
  }
  function i(o, u, a, s) {
    Promise.resolve(s).then(function(c) {
      o({ value: c, done: a });
    }, u);
  }
}
function b(e) {
  return typeof e == "function";
}
function me(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var oe = me(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function B(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var N = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var u = this._parentage;
      if (u)
        if (this._parentage = null, Array.isArray(u))
          try {
            for (var a = V(u), s = a.next(); !s.done; s = a.next()) {
              var c = s.value;
              c.remove(this);
            }
          } catch (h) {
            t = { error: h };
          } finally {
            try {
              s && !s.done && (n = a.return) && n.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          u.remove(this);
      var l = this.initialTeardown;
      if (b(l))
        try {
          l();
        } catch (h) {
          o = h instanceof oe ? h.errors : [h];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var v = V(d), p = v.next(); !p.done; p = v.next()) {
            var S = p.value;
            try {
              We(S);
            } catch (h) {
              o = o != null ? o : [], h instanceof oe ? o = R(R([], D(o)), D(h.errors)) : o.push(h);
            }
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            p && !p.done && (i = v.return) && i.call(v);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (o)
        throw new oe(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        We(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && B(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && B(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), Ye = N.EMPTY;
function Ge(e) {
  return e instanceof N || e && "closed" in e && b(e.remove) && b(e.add) && b(e.unsubscribe);
}
function We(e) {
  b(e) ? e() : e.unsubscribe();
}
var be = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, le = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var i = le.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, R([e, t], D(n))) : setTimeout.apply(void 0, R([e, t], D(n)));
  },
  clearTimeout: function(e) {
    var t = le.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function Je(e) {
  le.setTimeout(function() {
    throw e;
  });
}
function fe() {
}
var G = null;
function z(e) {
  if (be.useDeprecatedSynchronousErrorHandling) {
    var t = !G;
    if (t && (G = { errorThrown: !1, error: null }), e(), t) {
      var n = G, r = n.errorThrown, i = n.error;
      if (G = null, r)
        throw i;
    }
  } else
    e();
}
var ye = function(e) {
  x(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Ge(n) && n.add(r)) : r.destination = rn, r;
  }
  return t.create = function(n, r, i) {
    return new L(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(N), en = Function.prototype.bind;
function ue(e, t) {
  return en.call(e, t);
}
var tn = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        J(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        J(r);
      }
    else
      J(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        J(n);
      }
  }, e;
}(), L = function(e) {
  x(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, u;
    if (b(n) || !n)
      u = {
        next: n != null ? n : void 0,
        error: r != null ? r : void 0,
        complete: i != null ? i : void 0
      };
    else {
      var a;
      o && be.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return o.unsubscribe();
      }, u = {
        next: n.next && ue(n.next, a),
        error: n.error && ue(n.error, a),
        complete: n.complete && ue(n.complete, a)
      }) : u = n;
    }
    return o.destination = new tn(u), o;
  }
  return t;
}(ye);
function J(e) {
  Je(e);
}
function nn(e) {
  throw e;
}
var rn = {
  closed: !0,
  next: fe,
  error: nn,
  complete: fe
}, ge = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function W(e) {
  return e;
}
function on(e) {
  return e.length === 0 ? W : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var y = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = an(t) ? t : new L(t, n, r);
    return z(function() {
      var u = i, a = u.operator, s = u.source;
      o.add(a ? a.call(o, s) : s ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = qe(n), new n(function(i, o) {
      var u = new L({
        next: function(a) {
          try {
            t(a);
          } catch (s) {
            o(s), u.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(u);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[ge] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return on(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = qe(t), new t(function(r, i) {
      var o;
      n.subscribe(function(u) {
        return o = u;
      }, function(u) {
        return i(u);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function qe(e) {
  var t;
  return (t = e != null ? e : be.Promise) !== null && t !== void 0 ? t : Promise;
}
function un(e) {
  return e && b(e.next) && b(e.error) && b(e.complete);
}
function an(e) {
  return e && e instanceof ye || un(e) && Ge(e);
}
function sn(e) {
  return b(e == null ? void 0 : e.lift);
}
function _(e) {
  return function(t) {
    if (sn(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function w(e, t, n, r, i) {
  return new cn(e, t, n, r, i);
}
var cn = function(e) {
  x(t, e);
  function t(n, r, i, o, u, a) {
    var s = e.call(this, n) || this;
    return s.onFinalize = u, s.shouldUnsubscribe = a, s._next = r ? function(c) {
      try {
        r(c);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, s._error = o ? function(c) {
      try {
        o(c);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, s._complete = i ? function() {
      try {
        i();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, s;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(ye), ln = me(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ne = function(e) {
  x(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new Qe(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new ln();
  }, t.prototype.next = function(n) {
    var r = this;
    z(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var u = V(r.currentObservers), a = u.next(); !a.done; a = u.next()) {
            var s = a.value;
            s.next(n);
          }
        } catch (c) {
          i = { error: c };
        } finally {
          try {
            a && !a.done && (o = u.return) && o.call(u);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    z(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    z(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, o = i.hasError, u = i.isStopped, a = i.observers;
    return o || u ? Ye : (this.currentObservers = null, a.push(n), new N(function() {
      r.currentObservers = null, B(a, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, o = r.thrownError, u = r.isStopped;
    i ? n.error(o) : u && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new y();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new Qe(n, r);
  }, t;
}(y), Qe = function(e) {
  x(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : Ye;
  }, t;
}(ne), we = {
  now: function() {
    return (we.delegate || Date).now();
  },
  delegate: void 0
}, fn = function(e) {
  x(t, e);
  function t(n, r, i) {
    n === void 0 && (n = 1 / 0), r === void 0 && (r = 1 / 0), i === void 0 && (i = we);
    var o = e.call(this) || this;
    return o._bufferSize = n, o._windowTime = r, o._timestampProvider = i, o._buffer = [], o._infiniteTimeWindow = !0, o._infiniteTimeWindow = r === 1 / 0, o._bufferSize = Math.max(1, n), o._windowTime = Math.max(1, r), o;
  }
  return t.prototype.next = function(n) {
    var r = this, i = r.isStopped, o = r._buffer, u = r._infiniteTimeWindow, a = r._timestampProvider, s = r._windowTime;
    i || (o.push(n), !u && o.push(a.now() + s)), this._trimBuffer(), e.prototype.next.call(this, n);
  }, t.prototype._subscribe = function(n) {
    this._throwIfClosed(), this._trimBuffer();
    for (var r = this._innerSubscribe(n), i = this, o = i._infiniteTimeWindow, u = i._buffer, a = u.slice(), s = 0; s < a.length && !n.closed; s += o ? 1 : 2)
      n.next(a[s]);
    return this._checkFinalizedStatuses(n), r;
  }, t.prototype._trimBuffer = function() {
    var n = this, r = n._bufferSize, i = n._timestampProvider, o = n._buffer, u = n._infiniteTimeWindow, a = (u ? 1 : 2) * r;
    if (r < 1 / 0 && a < o.length && o.splice(0, o.length - a), !u) {
      for (var s = i.now(), c = 0, l = 1; l < o.length && o[l] <= s; l += 2)
        c = l;
      c && o.splice(0, c + 1);
    }
  }, t;
}(ne), dn = function(e) {
  x(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
}(N), X = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var i = X.delegate;
    return i != null && i.setInterval ? i.setInterval.apply(i, R([e, t], D(n))) : setInterval.apply(void 0, R([e, t], D(n)));
  },
  clearInterval: function(e) {
    var t = X.delegate;
    return ((t == null ? void 0 : t.clearInterval) || clearInterval)(e);
  },
  delegate: void 0
}, vn = function(e) {
  x(t, e);
  function t(n, r) {
    var i = e.call(this, n, r) || this;
    return i.scheduler = n, i.work = r, i.pending = !1, i;
  }
  return t.prototype.schedule = function(n, r) {
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var i = this.id, o = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(o, i, r)), this.pending = !0, this.delay = r, this.id = this.id || this.requestAsyncId(o, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, i) {
    return i === void 0 && (i = 0), X.setInterval(n.flush.bind(n, this), i);
  }, t.prototype.recycleAsyncId = function(n, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    X.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(n, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var i = !1, o;
    try {
      this.work(n);
    } catch (u) {
      i = !0, o = u || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, i = n.scheduler, o = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, B(o, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(dn), Ke = function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = we.now, e;
}(), hn = function(e) {
  x(t, e);
  function t(n, r) {
    r === void 0 && (r = Ke.now);
    var i = e.call(this, n, r) || this;
    return i.actions = [], i._active = !1, i._scheduled = void 0, i;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, i) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw i;
    }
  }, t;
}(Ke), _e = new hn(vn), pn = _e, Se = new y(function(e) {
  return e.complete();
});
function mn(e) {
  return e ? bn(e) : Se;
}
function bn(e) {
  return new y(function(t) {
    return e.schedule(function() {
      return t.complete();
    });
  });
}
function ze(e) {
  return e && b(e.schedule);
}
function Ze(e) {
  return e[e.length - 1];
}
function Ce(e) {
  return ze(Ze(e)) ? e.pop() : void 0;
}
function yn(e, t) {
  return typeof Ze(e) == "number" ? e.pop() : t;
}
var Be = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function Xe(e) {
  return b(e == null ? void 0 : e.then);
}
function et(e) {
  return b(e[ge]);
}
function tt(e) {
  return Symbol.asyncIterator && b(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function nt(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function gn() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var rt = gn();
function it(e) {
  return b(e == null ? void 0 : e[rt]);
}
function ot(e) {
  return Bt(this, arguments, function() {
    var n, r, i, o;
    return He(this, function(u) {
      switch (u.label) {
        case 0:
          n = e.getReader(), u.label = 1;
        case 1:
          u.trys.push([1, , 9, 10]), u.label = 2;
        case 2:
          return [4, U(n.read())];
        case 3:
          return r = u.sent(), i = r.value, o = r.done, o ? [4, U(void 0)] : [3, 5];
        case 4:
          return [2, u.sent()];
        case 5:
          return [4, U(i)];
        case 6:
          return [4, u.sent()];
        case 7:
          return u.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function ut(e) {
  return b(e == null ? void 0 : e.getReader);
}
function I(e) {
  if (e instanceof y)
    return e;
  if (e != null) {
    if (et(e))
      return wn(e);
    if (Be(e))
      return _n(e);
    if (Xe(e))
      return Sn(e);
    if (tt(e))
      return at(e);
    if (it(e))
      return Cn(e);
    if (ut(e))
      return En(e);
  }
  throw nt(e);
}
function wn(e) {
  return new y(function(t) {
    var n = e[ge]();
    if (b(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function _n(e) {
  return new y(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function Sn(e) {
  return new y(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, Je);
  });
}
function Cn(e) {
  return new y(function(t) {
    var n, r;
    try {
      for (var i = V(e), o = i.next(); !o.done; o = i.next()) {
        var u = o.value;
        if (t.next(u), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function at(e) {
  return new y(function(t) {
    xn(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function En(e) {
  return at(ot(e));
}
function xn(e, t) {
  var n, r, i, o;
  return pe(this, void 0, void 0, function() {
    var u, a;
    return He(this, function(s) {
      switch (s.label) {
        case 0:
          s.trys.push([0, 5, 6, 11]), n = Xt(e), s.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = s.sent(), !!r.done)
            return [3, 4];
          if (u = r.value, t.next(u), t.closed)
            return [2];
          s.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = s.sent(), i = { error: a }, [3, 11];
        case 6:
          return s.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          s.sent(), s.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function P(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function st(e, t) {
  return t === void 0 && (t = 0), _(function(n, r) {
    n.subscribe(w(r, function(i) {
      return P(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return P(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return P(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function ct(e, t) {
  return t === void 0 && (t = 0), _(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function In(e, t) {
  return I(e).pipe(ct(t), st(t));
}
function On(e, t) {
  return I(e).pipe(ct(t), st(t));
}
function kn(e, t) {
  return new y(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function An(e, t) {
  return new y(function(n) {
    var r;
    return P(n, t, function() {
      r = e[rt](), P(n, t, function() {
        var i, o, u;
        try {
          i = r.next(), o = i.value, u = i.done;
        } catch (a) {
          n.error(a);
          return;
        }
        u ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return b(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function lt(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new y(function(n) {
    P(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      P(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function Fn(e, t) {
  return lt(ot(e), t);
}
function Pn(e, t) {
  if (e != null) {
    if (et(e))
      return In(e, t);
    if (Be(e))
      return kn(e, t);
    if (Xe(e))
      return On(e, t);
    if (tt(e))
      return lt(e, t);
    if (it(e))
      return An(e, t);
    if (ut(e))
      return Fn(e, t);
  }
  throw nt(e);
}
function O(e, t) {
  return t ? Pn(e, t) : I(e);
}
function ee() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Ce(e);
  return O(e, n);
}
var ft = me(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function $n(e) {
  return e instanceof Date && !isNaN(e);
}
function C(e, t) {
  return _(function(n, r) {
    var i = 0;
    n.subscribe(w(r, function(o) {
      r.next(e.call(t, o, i++));
    }));
  });
}
function Tn(e, t, n, r, i, o, u, a) {
  var s = [], c = 0, l = 0, d = !1, v = function() {
    d && !s.length && !c && t.complete();
  }, p = function(h) {
    return c < r ? S(h) : s.push(h);
  }, S = function(h) {
    o && t.next(h), c++;
    var $ = !1;
    I(n(h, l++)).subscribe(w(t, function(E) {
      i == null || i(E), o ? p(E) : t.next(E);
    }, function() {
      $ = !0;
    }, void 0, function() {
      if ($)
        try {
          c--;
          for (var E = function() {
            var j = s.shift();
            u ? P(t, u, function() {
              return S(j);
            }) : S(j);
          }; s.length && c < r; )
            E();
          v();
        } catch (j) {
          t.error(j);
        }
    }));
  };
  return e.subscribe(w(t, p, function() {
    d = !0, v();
  })), function() {
    a == null || a();
  };
}
function Ee(e, t, n) {
  return n === void 0 && (n = 1 / 0), b(t) ? Ee(function(r, i) {
    return C(function(o, u) {
      return t(r, o, i, u);
    })(I(e(r, i)));
  }, n) : (typeof t == "number" && (n = t), _(function(r, i) {
    return Tn(r, i, e, n);
  }));
}
function dt(e) {
  return e === void 0 && (e = 1 / 0), Ee(W, e);
}
function Dn() {
  return dt(1);
}
function Rn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Dn()(O(e, Ce(e)));
}
function jn(e, t, n) {
  e === void 0 && (e = 0), n === void 0 && (n = pn);
  var r = -1;
  return t != null && (ze(t) ? n = t : r = t), new y(function(i) {
    var o = $n(e) ? +e - n.now() : e;
    o < 0 && (o = 0);
    var u = 0;
    return n.schedule(function() {
      i.closed || (i.next(u++), 0 <= r ? this.schedule(void 0, r) : i.complete());
    }, o);
  });
}
function Un() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Ce(e), r = yn(e, 1 / 0), i = e;
  return i.length ? i.length === 1 ? I(i[0]) : dt(r)(O(i, n)) : Se;
}
function Vn(e, t) {
  return _(function(n, r) {
    var i = 0;
    n.subscribe(w(r, function(o) {
      return e.call(t, o, i++) && r.next(o);
    }));
  });
}
function vt(e) {
  return _(function(t, n) {
    var r = null, i = !1, o;
    r = t.subscribe(w(n, void 0, void 0, function(u) {
      o = I(e(u, vt(e)(t))), r ? (r.unsubscribe(), r = null, o.subscribe(n)) : i = !0;
    })), i && (r.unsubscribe(), r = null, o.subscribe(n));
  });
}
function Mn(e, t, n, r, i) {
  return function(o, u) {
    var a = n, s = t, c = 0;
    o.subscribe(w(u, function(l) {
      var d = c++;
      s = a ? e(s, l, d) : (a = !0, l), r && u.next(s);
    }, i && function() {
      a && u.next(s), u.complete();
    }));
  };
}
function Ln(e, t) {
  return t === void 0 && (t = _e), _(function(n, r) {
    var i = null, o = null, u = null, a = function() {
      if (i) {
        i.unsubscribe(), i = null;
        var c = o;
        o = null, r.next(c);
      }
    };
    function s() {
      var c = u + e, l = t.now();
      if (l < c) {
        i = this.schedule(void 0, c - l), r.add(i);
        return;
      }
      a();
    }
    n.subscribe(w(r, function(c) {
      o = c, u = t.now(), i || (i = t.schedule(s, e), r.add(i));
    }, function() {
      a(), r.complete();
    }, void 0, function() {
      o = i = null;
    }));
  });
}
function Nn(e) {
  return _(function(t, n) {
    var r = !1;
    t.subscribe(w(n, function(i) {
      r = !0, n.next(i);
    }, function() {
      r || n.next(e), n.complete();
    }));
  });
}
function de(e) {
  return e <= 0 ? function() {
    return Se;
  } : _(function(t, n) {
    var r = 0;
    t.subscribe(w(n, function(i) {
      ++r <= e && (n.next(i), e <= r && n.complete());
    }));
  });
}
function Wn() {
  return _(function(e, t) {
    e.subscribe(w(t, fe));
  });
}
function qn(e) {
  return C(function() {
    return e;
  });
}
function ht(e, t) {
  return t ? function(n) {
    return Rn(t.pipe(de(1), Wn()), n.pipe(ht(e)));
  } : Ee(function(n, r) {
    return e(n, r).pipe(de(1), qn(n));
  });
}
function Qn(e, t) {
  t === void 0 && (t = _e);
  var n = jn(e, t);
  return ht(function() {
    return n;
  });
}
function Kn(e, t) {
  return t === void 0 && (t = W), e = e != null ? e : Hn, _(function(n, r) {
    var i, o = !0;
    n.subscribe(w(r, function(u) {
      var a = t(u);
      (o || !e(i, a)) && (o = !1, i = a, r.next(u));
    }));
  });
}
function Hn(e, t) {
  return e === t;
}
function Yn(e) {
  return e === void 0 && (e = Gn), _(function(t, n) {
    var r = !1;
    t.subscribe(w(n, function(i) {
      r = !0, n.next(i);
    }, function() {
      return r ? n.complete() : n.error(e());
    }));
  });
}
function Gn() {
  return new ft();
}
function pt(e, t) {
  var n = arguments.length >= 2;
  return function(r) {
    return r.pipe(e ? Vn(function(i, o) {
      return e(i, o, r);
    }) : W, de(1), n ? Nn(t) : Yn(function() {
      return new ft();
    }));
  };
}
function Jn(e, t) {
  return _(Mn(e, t, arguments.length >= 2, !0));
}
function zn(e) {
  e === void 0 && (e = {});
  var t = e.connector, n = t === void 0 ? function() {
    return new ne();
  } : t, r = e.resetOnError, i = r === void 0 ? !0 : r, o = e.resetOnComplete, u = o === void 0 ? !0 : o, a = e.resetOnRefCountZero, s = a === void 0 ? !0 : a;
  return function(c) {
    var l, d, v, p = 0, S = !1, h = !1, $ = function() {
      d == null || d.unsubscribe(), d = void 0;
    }, E = function() {
      $(), l = v = void 0, S = h = !1;
    }, j = function() {
      var M = l;
      E(), M == null || M.unsubscribe();
    };
    return _(function(M, Le) {
      p++, !h && !S && $();
      var H = v = v != null ? v : n();
      Le.add(function() {
        p--, p === 0 && !h && !S && (d = ae(j, s));
      }), H.subscribe(Le), !l && p > 0 && (l = new L({
        next: function(Y) {
          return H.next(Y);
        },
        error: function(Y) {
          h = !0, $(), d = ae(E, i, Y), H.error(Y);
        },
        complete: function() {
          S = !0, $(), d = ae(E, u), H.complete();
        }
      }), I(M).subscribe(l));
    })(c);
  };
}
function ae(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var i = new L({
      next: function() {
        i.unsubscribe(), e();
      }
    });
    return t.apply(void 0, R([], D(n))).subscribe(i);
  }
}
function Zn(e, t, n) {
  var r, i, o, u, a = !1;
  return e && typeof e == "object" ? (r = e.bufferSize, u = r === void 0 ? 1 / 0 : r, i = e.windowTime, t = i === void 0 ? 1 / 0 : i, o = e.refCount, a = o === void 0 ? !1 : o, n = e.scheduler) : u = e != null ? e : 1 / 0, zn({
    connector: function() {
      return new fn(u, t, n);
    },
    resetOnError: !0,
    resetOnComplete: !1,
    resetOnRefCountZero: a
  });
}
function mt(e, t) {
  return _(function(n, r) {
    var i = null, o = 0, u = !1, a = function() {
      return u && !i && r.complete();
    };
    n.subscribe(w(r, function(s) {
      i == null || i.unsubscribe();
      var c = 0, l = o++;
      I(e(s, l)).subscribe(i = w(r, function(d) {
        return r.next(t ? t(s, d, l, c++) : d);
      }, function() {
        i = null, a();
      }));
    }, function() {
      u = !0, a();
    }));
  });
}
function Bn(e, t, n) {
  var r = b(e) || t || n ? { next: e, error: t, complete: n } : e;
  return r ? _(function(i, o) {
    var u;
    (u = r.subscribe) === null || u === void 0 || u.call(r);
    var a = !0;
    i.subscribe(w(o, function(s) {
      var c;
      (c = r.next) === null || c === void 0 || c.call(r, s), o.next(s);
    }, function() {
      var s;
      a = !1, (s = r.complete) === null || s === void 0 || s.call(r), o.complete();
    }, function(s) {
      var c;
      a = !1, (c = r.error) === null || c === void 0 || c.call(r, s), o.error(s);
    }, function() {
      var s, c;
      a && ((s = r.unsubscribe) === null || s === void 0 || s.call(r)), (c = r.finalize) === null || c === void 0 || c.call(r);
    }));
  }) : W;
}
function xe(e) {
  return new y(function(t) {
    var n = Ft(e, t.next.bind(t), t.error.bind(t), t.complete.bind(t));
    return { unsubscribe: n };
  });
}
const Xn = "[DEFAULT]", bt = f.createContext(void 0), Ie = f.createContext(!1), er = "4.2.2", tr = (e, t) => e === t || [...Object.keys(e), ...Object.keys(t)].every((n) => e[n] === t[n]);
function Lr(e) {
  const {
    firebaseConfig: t,
    appName: n,
    suspense: r
  } = e, i = f.useMemo(() => {
    if (e.firebaseApp)
      return e.firebaseApp;
    const o = Vt().find((u) => u.name === (n || Xn));
    if (o) {
      if (t && tr(o.options, t))
        return o;
      throw new Error(`Does not match the options already provided to the ${n || "default"} firebase app instance, give this new instance a different appName.`);
    } else {
      if (!t)
        throw new Error("No firebaseConfig provided");
      const u = f.version || "unknown";
      return Ne("react", u), Ne("reactfire", er), Mt(t, n);
    }
  }, [e.firebaseApp, t, n]);
  return f.createElement(bt.Provider, {
    value: i
  }, f.createElement(Ie.Provider, Object.assign({
    value: r != null ? r : !1
  }, e)));
}
function Nr() {
  const e = f.useContext(Ie);
  return e != null ? e : !1;
}
function re(e) {
  let t = f.useContext(Ie);
  return e !== void 0 ? e : t;
}
function yt() {
  const e = f.useContext(bt);
  if (!e)
    throw new Error("Cannot call useFirebaseApp unless your component is within a FirebaseAppProvider");
  return e;
}
function Wr(e) {
  return pe(this, void 0, void 0, function* () {
    const t = yield e();
    return Ae(xe(t), `auth:user:${t.name}`).toPromise();
  });
}
function nr(e) {
  var t;
  const n = kt(), r = `auth:user:${n.name}`, i = xe(n), o = (t = Object.assign({}, e)) !== null && t !== void 0 ? t : {};
  return n.currentUser !== void 0 && (o.initialData = n.currentUser, o.startWithValue = n.currentUser), g(r, i, o);
}
function rr(e, t = !1, n) {
  if (!e)
    throw new Error("you must provide a user");
  const r = `auth:idTokenResult:${e.uid}:forceRefresh=${t}`, i = O(e.getIdTokenResult(t));
  return g(r, i, n);
}
function qr(e) {
  if ((e == null ? void 0 : e.hasOwnProperty("requiredClaims")) && (e == null ? void 0 : e.hasOwnProperty("validateCustomClaims")))
    throw new Error('Cannot have both "requiredClaims" and "validateCustomClaims". Use one or the other.');
  const t = kt();
  let n = `auth:signInCheck:${t.name}::forceRefresh:${!!(e != null && e.forceRefresh)}`;
  e != null && e.forceRefresh && (n = `${n}:forceRefresh:${e.forceRefresh}`), e != null && e.hasOwnProperty("requiredClaims") ? n = `${n}:requiredClaims:${JSON.stringify(e.requiredClaims)}` : e != null && e.hasOwnProperty("validateCustomClaims") && (n = `${n}:validateCustomClaims:${JSON.stringify(e.validateCustomClaims)}`);
  const r = xe(t).pipe(mt((i) => {
    var o;
    return i ? e && (e.hasOwnProperty("requiredClaims") || e.hasOwnProperty("validateCustomClaims")) ? O(i.getIdTokenResult((o = e == null ? void 0 : e.forceRefresh) !== null && o !== void 0 ? o : !1)).pipe(C((u) => {
      let a;
      e.hasOwnProperty("requiredClaims") ? a = ir(e.requiredClaims) : a = e.validateCustomClaims;
      const {
        hasRequiredClaims: s,
        errors: c
      } = a(u.claims);
      return {
        signedIn: !0,
        hasRequiredClaims: s,
        errors: c,
        user: i
      };
    })) : ee({
      signedIn: !0,
      hasRequiredClaims: !0,
      errors: {},
      user: i
    }) : ee({
      signedIn: !1,
      hasRequiredClaims: !1,
      errors: {},
      user: null
    });
  }));
  return g(n, r);
}
function ir(e) {
  return function(n) {
    const r = {};
    return Object.keys(e).forEach((i) => {
      e[i] !== n[i] && (r[i] = [new Me("auth/missing-claim", `Expected "${e[i]}", but user has "${n[i]}" instead`)]);
    }), {
      hasRequiredClaims: Object.keys(r).length === 0,
      errors: r
    };
  };
}
function or({
  user: e,
  fallback: t,
  children: n,
  requiredClaims: r
}) {
  const {
    data: i
  } = rr(e, !1), {
    claims: o
  } = i, u = {};
  return re() || console.warn("ClaimsCheck is deprecated and only works when ReactFire is in experimental Suspense Mode. Use useSigninCheck or set suspense={true} in FirebaseAppProvider if you want to use this component."), r && Object.keys(r).forEach((s) => {
    var c;
    r[s] !== o[s] && (u[s] = {
      expected: r[s],
      actual: (c = o[s]) === null || c === void 0 ? void 0 : c.toString()
    });
  }), Object.keys(u).length === 0 ? f.createElement(f.Fragment, null, n) : f.createElement(f.Fragment, null, t);
}
function Qr({
  fallback: e,
  children: t,
  requiredClaims: n
}) {
  const {
    data: r
  } = nr();
  return re() || console.warn("AuthCheck is deprecated and only works when ReactFire is in experimental Suspense Mode. Use useSigninCheck or set suspense={true} in FirebaseAppProvider if you want to use this component."), r ? n ? f.createElement(or, {
    user: r,
    fallback: e,
    requiredClaims: n
  }, t) : f.createElement(f.Fragment, null, t) : f.createElement(f.Fragment, null, e);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var te = function() {
  return te = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, te.apply(this, arguments);
};
function se(e, t) {
  for (var n = 0, r = t.length, i = e.length; n < r; n++, i++)
    e[i] = t[n];
  return e;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var T, m;
(function(e) {
  e.added = "child_added", e.removed = "child_removed", e.changed = "child_changed", e.moved = "child_moved", e.value = "value";
})(m || (m = {}));
var ur = Object.freeze((T = {}, T[m.added] = Pt, T[m.removed] = $t, T[m.changed] = Tt, T[m.moved] = Dt, T[m.value] = Rt, T));
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Oe(e, t) {
  return new y(function(n) {
    var r = ur[t](e, function(i, o) {
      n.next({ snapshot: i, prevKey: o, event: t });
    }, n.error.bind(n));
    return {
      unsubscribe: function() {
        jt(e, t, r);
      }
    };
  }).pipe(Qn(0));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ar(e) {
  return (e == null || e.length === 0) && (e = [
    m.added,
    m.removed,
    m.changed,
    m.moved
  ]), e;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sr(e) {
  return Oe(e, m.value);
}
function cr(e, t) {
  return t === void 0 && (t = {}), Oe(e, m.value).pipe(C(function(n) {
    return gt(n, t);
  }));
}
function gt(e, t) {
  var n;
  t === void 0 && (t = {});
  var r = e.snapshot.val();
  return !e.snapshot.exists() || typeof r != "object" ? r : te(te({}, r), t.keyField ? (n = {}, n[t.keyField] = e.snapshot.key, n) : null);
}
function lr(e) {
  return O(Ut(e)).pipe(C(function(t) {
    var n = m.value;
    return { snapshot: t, prevKey: null, event: n };
  }));
}
function wt(e, t) {
  t === void 0 && (t = {});
  var n = ar(t.events);
  return lr(e).pipe(mt(function(r) {
    if (!r.snapshot.exists())
      return ee([]);
    var i = [ee(r)];
    return n.forEach(function(o) {
      i.push(Oe(e, o));
    }), Un.apply(void 0, i).pipe(Jn(vr, []));
  }), Kn());
}
function fr(e, t) {
  return t === void 0 && (t = {}), wt(e).pipe(C(function(n) {
    return n.map(function(r) {
      return gt(r, t);
    });
  }));
}
function _t(e, t) {
  for (var n = e.length, r = 0; r < n; r++)
    if (e[r].snapshot.key === t)
      return r;
  return -1;
}
function dr(e, t) {
  if (t == null)
    return 0;
  var n = _t(e, t);
  return n === -1 ? e.length : n + 1;
}
function vr(e, t) {
  var n = t.snapshot, r = t.prevKey, i = t.event, o = n.key, u = _t(e, o), a = dr(e, r || void 0);
  switch (i) {
    case m.value:
      if (t.snapshot && t.snapshot.exists()) {
        var s = null;
        t.snapshot.forEach(function(d) {
          var v = {
            snapshot: d,
            event: m.value,
            prevKey: s
          };
          return s = d.key, e = se(se([], e), [v]), !1;
        });
      }
      return e;
    case m.added:
      if (u > -1) {
        var c = e[u - 1];
        (c && c.snapshot.key || null) !== r && (e = e.filter(function(d) {
          return d.snapshot.key !== n.key;
        }), e.splice(a, 0, t));
      } else {
        if (r == null)
          return se([t], e);
        e = e.slice(), e.splice(a, 0, t);
      }
      return e;
    case m.removed:
      return e.filter(function(d) {
        return d.snapshot.key !== n.key;
      });
    case m.changed:
      return e.map(function(d) {
        return d.snapshot.key === o ? t : d;
      });
    case m.moved:
      if (u > -1) {
        var l = e.splice(u, 1)[0];
        return e = e.slice(), e.splice(a, 0, l), e;
      }
      return e;
    default:
      return e;
  }
}
const ve = globalThis._reactFireDatabaseCachedQueries || [];
globalThis._reactFireDatabaseCachedQueries || (globalThis._reactFireDatabaseCachedQueries = ve);
function St(e) {
  const t = ve.findIndex((n) => n.isEqual(e));
  return t > -1 ? t : ve.push(e) - 1;
}
function Kr(e, t) {
  const n = `database:object:${e.toString()}`, r = sr(e);
  return g(n, r, t);
}
function Hr(e, t) {
  const n = t ? K(t) : "NO_ID_FIELD", r = `database:objectVal:${e.toString()}:idField=${n}`, i = cr(e, {
    keyField: n
  });
  return g(r, i, t);
}
function Yr(e, t) {
  const n = `database:list:${St(e)}`, r = wt(e);
  return g(n, r, t);
}
function Gr(e, t) {
  const n = t ? K(t) : "NO_ID_FIELD", r = `database:listVal:${St(e)}:idField=${n}`, i = fr(e, {
    keyField: n
  });
  return g(r, i, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var hr = { includeMetadataChanges: !1 };
function ke(e, t) {
  return t === void 0 && (t = hr), new y(function(n) {
    var r = Lt(e, t, {
      next: n.next.bind(n),
      error: n.error.bind(n),
      complete: n.complete.bind(n)
    });
    return { unsubscribe: r };
  });
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ie(e) {
  return ke(e, { includeMetadataChanges: !0 });
}
function Ct(e, t) {
  return t === void 0 && (t = {}), ie(e).pipe(C(function(n) {
    return Et(n, t);
  }));
}
function Et(e, t) {
  t === void 0 && (t = {});
  var n = e.data();
  return !e.exists() || typeof n != "object" || n === null || t.idField && (n[t.idField] = e.id), n;
}
function pr(e) {
  return ke(e, { includeMetadataChanges: !0 }).pipe(C(function(t) {
    return t.docs;
  }));
}
function mr(e, t) {
  return t === void 0 && (t = {}), pr(e).pipe(C(function(n) {
    return n.map(function(r) {
      return Et(r, t);
    });
  }));
}
class br extends ne {
  constructor(t, n) {
    super(), this._timeoutWindow = n, this._hasValue = !1, this._error = void 0, this._firstEmission = new Promise((r) => this._resolveFirstEmission = r), this._innerObservable = t.pipe(Bn({
      next: (r) => {
        this._next(r);
      },
      error: (r) => {
        this._error = r, this._resolveFirstEmission();
      }
    }), vt(() => mn()), Zn(1)), this._warmupSubscription = this._innerObservable.subscribe(), this._timeoutHandler = setTimeout(this._reset.bind(this), this._timeoutWindow);
  }
  get hasValue() {
    return this._hasValue || !!this._error;
  }
  get value() {
    if (this._error)
      throw this._error;
    if (!this.hasValue)
      throw Error("Can only get value if SuspenseSubject has a value");
    return this._value;
  }
  get firstEmission() {
    return this._firstEmission;
  }
  _next(t) {
    this._hasValue = !0, this._value = t, this._resolveFirstEmission();
  }
  _reset() {
    this._warmupSubscription && this._warmupSubscription.unsubscribe(), this._hasValue = !1, this._value = void 0, this._error = void 0, this._firstEmission = new Promise((t) => this._resolveFirstEmission = t);
  }
  _subscribe(t) {
    return this._timeoutHandler && clearTimeout(this._timeoutHandler), this._innerSubscriber = this._innerObservable.subscribe(t), this._innerSubscriber;
  }
  get ourError() {
    return this._error;
  }
}
const yr = 3e4, Z = globalThis._reactFirePreloadedObservables || /* @__PURE__ */ new Map();
globalThis._reactFirePreloadedObservables || (globalThis._reactFirePreloadedObservables = Z);
function Ae(e, t) {
  if (Z.has(t))
    return Z.get(t);
  {
    const n = new br(e, yr);
    return Z.set(t, n), n;
  }
}
function gr(e) {
  return function(n, r) {
    const i = Object.assign(Object.assign({}, n), { hasEmitted: n.hasEmitted || e.hasValue, error: e.ourError, firstValuePromise: e.firstEmission });
    switch (e.hasValue && (i.data = e.value), r) {
      case "value":
        return i.status = "success", i;
      case "error":
        return i.status = "error", i;
      case "complete":
        return i.isComplete = !0, i;
      default:
        throw new Error(`invalid action "${r}"`);
    }
  };
}
function g(e, t, n = {}) {
  var r;
  if (!e)
    throw new Error("cannot call useObservable without an observableId");
  const i = Ae(t, e), o = n.hasOwnProperty("initialData") || n.hasOwnProperty("startWithValue"), u = i.hasValue || o;
  if (re(n.suspense) === !0 && !u)
    throw i.firstEmission;
  const s = {
    status: u ? "success" : "loading",
    hasEmitted: u,
    isComplete: !1,
    data: i.hasValue ? i.value : (r = n == null ? void 0 : n.initialData) !== null && r !== void 0 ? r : n == null ? void 0 : n.startWithValue,
    error: i.ourError,
    firstValuePromise: i.firstEmission
  }, [c, l] = f.useReducer(gr(i), s);
  return f.useEffect(() => {
    const d = i.subscribe({
      next: () => {
        l("value");
      },
      error: (v) => {
        throw l("error"), v;
      },
      complete: () => {
        l("complete");
      }
    });
    return () => d.unsubscribe();
  }, [i]), c;
}
const he = globalThis._reactFireFirestoreQueryCache || [];
globalThis._reactFireFirestoreQueryCache || (globalThis._reactFireFirestoreQueryCache = he);
function xt(e) {
  const t = he.findIndex((n) => Nt(n, e));
  return t > -1 ? t : he.push(e) - 1;
}
function Jr(e) {
  return pe(this, void 0, void 0, function* () {
    const t = yield e();
    return Ae(ie(t), It(t));
  });
}
function It(e) {
  return `firestore:doc:${e.firestore.app.name}:${e.path}`;
}
function zr(e, t) {
  const n = It(e), r = ie(e);
  return g(n, r, t);
}
function Zr(e, t) {
  const n = `firestore:docOnce:${e.firestore.app.name}:${e.path}`, r = ie(e).pipe(pt());
  return g(n, r, t);
}
function Br(e, t) {
  const n = t ? K(t) : "NO_ID_FIELD", r = `firestore:docData:${e.firestore.app.name}:${e.path}:idField=${n}`, i = Ct(e, {
    idField: n
  });
  return g(r, i, t);
}
function Xr(e, t) {
  const n = t ? K(t) : "NO_ID_FIELD", r = `firestore:docDataOnce:${e.firestore.app.name}:${e.path}:idField=${n}`, i = Ct(e, {
    idField: n
  }).pipe(pt());
  return g(r, i, t);
}
function ei(e, t) {
  const n = `firestore:collection:${xt(e)}`, r = ke(e);
  return g(n, r, t);
}
function ti(e, t) {
  const n = t ? K(t) : "NO_ID_FIELD", r = `firestore:collectionData:${xt(e)}:idField=${n}`, i = mr(e, {
    idField: n
  });
  return g(r, i, t);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function wr(e, t, n) {
  var r = Wt(e, t, n);
  return function(i) {
    return O(r(i)).pipe(C(function(o) {
      return o.data;
    }));
  };
}
function ni(e, t) {
  const n = Fr(), r = `functions:callableResponse:${e}:${JSON.stringify(t == null ? void 0 : t.data)}:${JSON.stringify(t == null ? void 0 : t.httpsCallableOptions)}`, o = wr(n, e, t == null ? void 0 : t.httpsCallableOptions)(t == null ? void 0 : t.data);
  return g(r, o, t);
}
function ri({
  children: e,
  traceId: t,
  fallback: n
}) {
  var r;
  const i = ((r = performance == null ? void 0 : performance.getEntriesByName) === null || r === void 0 ? void 0 : r.call(performance, t, "measure")) || [], o = `_${t}Start[${i.length}]`, u = `_${t}End[${i.length}]`, a = () => (f.useLayoutEffect(() => {
    var s;
    return (s = performance == null ? void 0 : performance.mark) === null || s === void 0 || s.call(performance, o), () => {
      var c, l;
      (c = performance == null ? void 0 : performance.mark) === null || c === void 0 || c.call(performance, u), (l = performance == null ? void 0 : performance.measure) === null || l === void 0 || l.call(performance, t, o, u);
    };
  }, []), f.createElement(f.Fragment, null, n));
  return f.createElement(f.Suspense, {
    fallback: f.createElement(a, null)
  }, e);
}
function q(e) {
  var t = e.remoteConfig, n = e.key, r = e.getter;
  return new y(function(i) {
    Kt(t).then(function() {
      var o = r.bind(t);
      i.next(o(t, n));
    });
  });
}
function _r(e, t) {
  var n = Ht;
  return q({ remoteConfig: e, key: t, getter: n });
}
function Sr(e, t) {
  var n = Yt;
  return q({ remoteConfig: e, key: t, getter: n });
}
function Cr(e, t) {
  var n = Gt;
  return q({ remoteConfig: e, key: t, getter: n });
}
function Er(e, t) {
  var n = Jt;
  return q({ remoteConfig: e, key: t, getter: n });
}
function xr(e) {
  var t = zt;
  return q({ remoteConfig: e, key: "", getter: t });
}
function Q(e, t) {
  const n = $r(), r = n.app.name, i = t(n, e), o = `remoteConfig:${e}:${t.name}:${r}`;
  return g(o, i);
}
function ii(e) {
  return Q(e, _r);
}
function oi(e) {
  return Q(e, Sr);
}
function ui(e) {
  return Q(e, Cr);
}
function ai(e) {
  return Q(e, Er);
}
function si(e) {
  return Q(e, xr);
}
function Ir(e) {
  return new y(function(t) {
    var n = function(u) {
      return t.next(u);
    }, r = function(u) {
      return t.error(u);
    }, i = function() {
      return t.complete();
    };
    n(e.snapshot);
    var o = e.on("state_changed", n);
    return e.then(function(u) {
      n(u), setTimeout(function() {
        return i();
      }, 0);
    }, function(u) {
      n(e.snapshot), setTimeout(function() {
        return r(u);
      }, 0);
    }), function() {
      o();
    };
  }).pipe(Ln(0));
}
function Or(e) {
  return O(qt(e));
}
function ci(e, t, n) {
  const r = `storage:task:${t.toString()}`, i = Ir(e);
  return g(r, i, n);
}
function kr(e, t) {
  const n = `storage:downloadUrl:${e.toString()}`, r = Or(e);
  return g(n, r, t);
}
function Ar(e) {
  const t = Pr();
  return e = Object.assign(Object.assign({}, e), {
    storage: t
  }), f.createElement(Ot, Object.assign({}, e));
}
function Ot(e) {
  let {
    storage: t,
    storagePath: n,
    suspense: r,
    placeHolder: i
  } = e, o = Zt(e, ["storage", "storagePath", "suspense", "placeHolder"]);
  const u = {
    suspense: re(r)
  };
  if (!t)
    throw new Error("Storage was not passed to component INTERNALStorageImage. This should not be possible");
  const {
    status: a,
    data: s
  } = kr(Qt(t, n), u);
  return a === "success" ? (o.alt || o.alt === "" || console.warn(`No alt prop provided for StorageImage with storagePath "${n}"`, "img elements must have an alt prop, either with meaningful text, or an empty string for decorative images"), f.createElement("img", Object.assign({
    src: s,
    alt: o.alt
  }, o))) : i != null ? i : f.createElement(f.Fragment, null, "''");
}
function li(e) {
  let {
    storage: t
  } = e;
  return t ? f.createElement(Ot, Object.assign({}, e)) : f.createElement(Ar, Object.assign({}, e));
}
const Fe = f.createContext(void 0), Pe = f.createContext(void 0), $e = f.createContext(void 0), Te = f.createContext(void 0), De = f.createContext(void 0), Re = f.createContext(void 0), je = f.createContext(void 0), Ue = f.createContext(void 0), Ve = f.createContext(void 0);
function k(e) {
  return function(n) {
    var r, i;
    if (!n.sdk)
      throw new Error("no sdk provided");
    const o = yt().name;
    if (((i = (r = n == null ? void 0 : n.sdk) === null || r === void 0 ? void 0 : r.app) === null || i === void 0 ? void 0 : i.name) !== o)
      throw new Error("sdk was initialized with a different firebase app");
    return f.createElement(e.Provider, Object.assign({
      value: n.sdk
    }, n));
  };
}
function A(e) {
  const t = f.useContext(e);
  if (!t)
    throw new Error("SDK not found. useSdk must be called from within a provider");
  return t;
}
function F(e, t, n, r) {
  const i = yt();
  if (f.useContext(t))
    throw new Error(`Cannot initialize SDK ${e} because it already exists in Context`);
  const o = f.useMemo(() => n(i), [i]);
  return g(`firebase-sdk:${e}:${i.name}`, O(o), r);
}
const fi = k(Fe), di = k(Pe), vi = k($e), hi = k(Te), pi = k(De), mi = k(Re), bi = k(Ue), yi = k(je), gi = k(Ve), wi = () => A(Fe), kt = () => A(Pe), _i = () => A($e), Si = () => A(Te), Ci = () => A(De), Fr = () => A(Re), Ei = () => A(Ue), Pr = () => A(je), $r = () => A(Ve), xi = (e, t) => F("appcheck", Fe, e, t), Ii = (e, t) => F("auth", Pe, e, t), Oi = (e, t) => F("analytics", $e, e, t), ki = (e, t) => F("database", Te, e, t), Ai = (e, t) => F("firestore", De, e, t), Fi = (e, t) => F("functions", Re, e, t), Pi = (e, t) => F("performance", Ue, e, t), $i = (e, t) => F("remoteconfig", Ve, e, t), Ti = (e, t) => F("storage", je, e, t);
class Me extends Error {
  constructor(t, n, r) {
    super(n), this.code = t, this.customData = r, this.name = "ReactFireError", Object.setPrototypeOf(this, Me.prototype);
  }
}
function At(e, t) {
  if (t === "idField" || t === "initialData" || t === "suspense")
    return e ? e[t] : void 0;
  throw new Error(`Field "${t}" is not a valid key in ReactFireOptions`);
}
function Di(e) {
  return At(e, "initialData");
}
function K(e) {
  return At(e, "idField");
}
export {
  vi as AnalyticsProvider,
  $e as AnalyticsSdkContext,
  fi as AppCheckProvider,
  Fe as AppCheckSdkContext,
  Qr as AuthCheck,
  di as AuthProvider,
  Pe as AuthSdkContext,
  or as ClaimsCheck,
  hi as DatabaseProvider,
  Te as DatabaseSdkContext,
  Lr as FirebaseAppProvider,
  pi as FirestoreProvider,
  De as FirestoreSdkContext,
  mi as FunctionsProvider,
  Re as FunctionsSdkContext,
  bi as PerformanceProvider,
  Ue as PerformanceSdkContext,
  Me as ReactFireError,
  gi as RemoteConfigProvider,
  Ve as RemoteConfigSdkContext,
  li as StorageImage,
  yi as StorageProvider,
  je as StorageSdkContext,
  ri as SuspenseWithPerf,
  K as checkIdField,
  At as checkOptions,
  Di as checkinitialData,
  Jr as preloadFirestoreDoc,
  Ae as preloadObservable,
  Wr as preloadUser,
  _i as useAnalytics,
  wi as useAppCheck,
  kt as useAuth,
  ni as useCallableFunctionResponse,
  Si as useDatabase,
  Yr as useDatabaseList,
  Gr as useDatabaseListData,
  Kr as useDatabaseObject,
  Hr as useDatabaseObjectData,
  yt as useFirebaseApp,
  Ci as useFirestore,
  ei as useFirestoreCollection,
  ti as useFirestoreCollectionData,
  zr as useFirestoreDoc,
  Br as useFirestoreDocData,
  Xr as useFirestoreDocDataOnce,
  Zr as useFirestoreDocOnce,
  Fr as useFunctions,
  rr as useIdTokenResult,
  Oi as useInitAnalytics,
  xi as useInitAppCheck,
  Ii as useInitAuth,
  ki as useInitDatabase,
  Ai as useInitFirestore,
  Fi as useInitFunctions,
  Pi as useInitPerformance,
  $i as useInitRemoteConfig,
  Ti as useInitStorage,
  Nr as useIsSuspenseEnabled,
  g as useObservable,
  Ei as usePerformance,
  $r as useRemoteConfig,
  si as useRemoteConfigAll,
  ai as useRemoteConfigBoolean,
  ui as useRemoteConfigNumber,
  oi as useRemoteConfigString,
  ii as useRemoteConfigValue,
  qr as useSigninCheck,
  Pr as useStorage,
  kr as useStorageDownloadURL,
  ci as useStorageTask,
  re as useSuspenseEnabledFromConfigAndContext,
  nr as useUser,
  er as version
};
//# sourceMappingURL=index.js.map
